import React from 'react';
import NoCartItem from './Checkout/NoCartItem';
import CartItemBox from './Checkout/CartItemBox';
import ShippingMethod from './Checkout/ShippingMethod';
import PaymentMethod from './Checkout/PaymentMethod';
import OrderSummary from './Checkout/OrderSummary';
import CheckOutButton from './Checkout/CheckoutButton';

const CheckoutSteps = ({
  fullCartInfo,
  setFullCartInfo,
  setCurrentStep,
  pk_key,
  setIsLoading,
  selectedUser,
  shippingMethods,
  setShippingMethods,
  selectedShippingMethod,
  setSelectedShippingMethod,
  selectedShipmentMethod,
  setSelectedShipmentMethod,
  selectedExternalShipmentMethod,
  setSelectedExternalShipmentMethod,
  selectedShipmentAddress,
  setSelectedShipmentAddress,
  paymentMethods,
  selectedPaymentMethod,
  setSelectedPaymentMethod,
  clickCheckOut,
  isLoading,
}) => {
  return (
    <div className="flex flex-col gap-4 w-full p-4  ">
      {fullCartInfo?.cart_details?.length > 0 ? (
        <>
          <CartItemBox
            fullCartInfo={fullCartInfo}
            setFullCartInfo={setFullCartInfo}
            pk_key={pk_key}
            setIsLoading={setIsLoading}
            selectedUser={selectedUser}
          />
          <ShippingMethod
            shippingMethods={shippingMethods}
            setShippingMethods={setShippingMethods}
            selectedShippingMethod={selectedShippingMethod}
            setSelectedShippingMethod={setSelectedShippingMethod}
            selectedShipmentMethod={selectedShipmentMethod}
            setSelectedShipmentMethod={setSelectedShipmentMethod}
            selectedExternalShipmentMethod={selectedExternalShipmentMethod}
            setSelectedExternalShipmentMethod={
              setSelectedExternalShipmentMethod
            }
            selectedShipmentAddress={selectedShipmentAddress}
            setSelectedShipmentAddress={setSelectedShipmentAddress}
          />
          <PaymentMethod
            paymentMethods={paymentMethods}
            selectedPaymentMethod={selectedPaymentMethod}
            setSelectedPaymentMethod={setSelectedPaymentMethod}
          />
          <OrderSummary
            cart={fullCartInfo?.cart}
            cart_details={fullCartInfo?.cart_details}
            shippingMethod={selectedShippingMethod}
            setFullCartInfo={setFullCartInfo}
            setIsLoading={setIsLoading}
            selectedUser={selectedUser}
            pk_key={pk_key}
          />
          <CheckOutButton clickCheckOut={clickCheckOut} isLoading={isLoading} />
        </>
      ) : (
        <NoCartItem />
      )}
    </div>
  );
};

export default CheckoutSteps;
